import { LoginForm } from '../components/auth/LoginForm';
import { Card, Flex, Typography } from 'antd';

export const LoginPage = () => {
  return (
    <Flex vertical align="center" gap="md">
      <Typography.Title>Crown Sitter</Typography.Title>
      <Typography.Text>シッター用アプリ</Typography.Text>
      <Card style={{ marginTop: 10 }}>
        <LoginForm />
      </Card>
    </Flex>
  );
};
